<template>
    <div class="exercise_detail_left" v-if="practice">
        <div class="main_left">
            <div class="img_box mb24">
                <div class="img_con">
                    <img
                        v-if="practice.drawingThumbnail && switchType === 'image'"
                        :src="practice.drawingThumbnail"
                        alt
                        @click="animationPlay('img')"
                    />
                    <img
                        v-if="!practice.drawingThumbnail && switchType === 'image'"
                        src="@i/exercise/formation_bg.svg"
                        alt
                        @click="animationPlay('img')"
                    />
                    <div v-if="switchType === 'animation'" class="img_con_video">
                        <img
                            v-if="practice.drawAnimatedUrl && practice.drawingThumbnail"
                            :src="practice.drawingThumbnail"
                        />
                        <img v-else src="@i/exercise/formation_bg.svg" alt />
                        <div class="video_layer">
                            <img src="@i/exercise/video_play.svg" alt @click="animationPlay('animation')" />
                        </div>
                    </div>
                </div>
                <div class="img_switch">
                    <div :class="{ active: switchType === 'image' }" @click="switchType = 'image'" v-waves>
                        <img
                            :src="require('@i/exercise/exercise_image_active.svg')"
                            alt
                            v-if="switchType === 'image'"
                        />
                        <img :src="require('@i/exercise/exercise_image.svg')" alt v-else />
                    </div>
                    <div :class="{ active: switchType === 'animation' }" @click="switchType = 'animation'" v-waves>
                        <img
                            :src="require('@i/exercise/exercise_animation_active.svg')"
                            alt
                            v-if="switchType === 'animation'"
                        />
                        <img :src="require('@i/exercise/exercise_animation.svg')" alt v-else />
                    </div>
                </div>
                <div v-if="action !== 'view'" class="view_edit" @click="toDraw">
                    <cl-svg-icon iconClass="edit" width="24" style="color:#fff"></cl-svg-icon>
                </div>
            </div>
        </div>
        <!-- 图片/动画弹窗 -->
        <animation-dialog
            v-if="practice.drawAnimatedUrl || practice.drawingThumbnail"
            :fileType="switchType === 'animation' ? 'video' : 'img'"
            :visible="visible"
            :dataInfo="practice"
            :templateItem="templateItem"
            @updateVisible="visible = false"
        ></animation-dialog>
        <!-- 教案编辑页面 -->
        <el-dialog
            :visible.sync="iframeVisible"
            class="practice_dialog"
            :show-close="false"
            custom-class="noHeaderFooter"
        >
            <iframe
                v-if="iframeVisible"
                id="draw_wrapper"
                :src="iframeSrc"
                ref="iframe"
                style="height:100%;width:100%"
            ></iframe>
        </el-dialog>
    </div>
</template>
<script>
    import animationDialog from './animation-dialog.vue'
    export default {
        components: {
            animationDialog,
        },
        props: {
            practice: {
                type: Object,
                default: () => {},
            },
            action: {
                type: String,
                default: 'view',
            },
            templateItem: {
                type: Object,
                default: () => ({}),
            },
        },
        computed: {},
        data() {
            return {
                switchType: 'image', // 查看图片或者动画
                visible: false, // 弹窗的显示隐藏
                iframeVisible: false, // 画图工具的显示隐藏
                iframeSrc: '', // 画图工具的地址
            }
        },
        methods: {
            // 图片/视频
            animationPlay(type) {
                if (this.practice.drawAnimatedUrl && type == 'animation') {
                    this.visible = true
                } else if (this.practice.drawingThumbnail && type == 'img') {
                    this.visible = true
                } else if (!this.practice.drawingThumbnail && type == 'img') {
                    this.$message.warning(this.$t('exercise.暂无图片'))
                } else if (!this.practice.drawAnimatedUrl && type == 'animation') {
                    this.$message.warning(this.$t('exercise.暂无动画'))
                }
            },
            // 打开画图工具
            toDraw() {
                const urlStr = this.$baseUrl.fabricURL
                const backgroundColor =
                    this.practice.backgroundColor && this.practice.backgroundColor.length
                        ? this.practice.backgroundColor.slice(1)
                        : ''
                const drawId = this.practice.drawId ? this.practice.drawId : ''
                const token = this.$store.state.token ? this.$store.state.token : ''
                const xTenantId = this.$store.state.groupId ? this.$store.state.groupId : ''
                this.iframeSrc = `${urlStr}?audience=managepilot&product=drawtool&language=${
                    this.$store.state.language
                }&id=${drawId}&backgroundColor=${backgroundColor}&token=${token}&xTenantId=${xTenantId}`
                this.iframeVisible = true;
                this.setIframeMessage();
            },
            // 监听是否进入动画教案编辑页面
            handleMessage(event) {
                let data = event.data.data
                if (!data) return
                if (data.code === 'mounted') {
                    return
                }
                this.iframeVisible = false
                // console.log(data.code)
                // return;
                if (data.code === 'back') return
                if (data.notes) {
                    this.practice.notes = data.notes
                }
                if (data.backgroundColor) {
                    this.practice.backgroundColor = data.backgroundColor
                }
                if (data.drawImg || data.drawAnimated) {
                    /* 上传教案库图片 */
                    if (data.drawImg) {
                        this.practice.drawingThumbnail = data.drawImgUrl
                    }
                    /* 上传教案库动画 */
                    if (data.drawAnimated) {
                        this.practice.drawAnimatedUrl = data.drawAnimatedUrl
                    } else {
                        this.animationFlag = true
                    }
                }
            },
            // iframe加载完成后 向fabric发送notes数据
            setIframeMessage() {
                setTimeout(() => {
                    const dom = document.getElementById("draw_wrapper");
                    const notes = this.practice.notes ? this.practice.notes : ''
                    dom.onload = () => {
                        const shareData = {
                            type: "notes",
                            data: encodeURIComponent(notes),
                        };
                        dom.contentWindow.postMessage(shareData, "*");
                    };
                }, 20);
            }
        },
        mounted() {
            window.addEventListener('message', this.handleMessage)
        },
        destroyed() {
            window.removeEventListener('message', this.handleMessage)
        },
    }
</script>
<style lang="scss" scoped>
    .main_left {
        width: 338px;
        margin-right: 20px;
        .img_box {
            height: 447px;
            position: relative;
            .img_con {
                height: 100%;
                img {
                    width: 100%;
                    height: 100%;
                    border-radius: 6px;
                }
                &_video {
                    height: 100%;
                    position: relative;
                    .video_layer {
                        top: 0;
                        left: 0;
                        position: absolute;
                        height: 100%;
                        width: 100%;
                        background: rgba($color: #2f2222, $alpha: 0.1);
                        border-radius: 6px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        cursor: pointer;
                        img {
                            height: 48px;
                            width: 48px;
                        }
                    }
                }
            }
            .img_switch {
                height: 36px;
                width: 120px;
                display: flex;
                align-items: center;
                box-sizing: border-box;
                background: rgba($color: #000000, $alpha: 0.32);
                border-radius: 27px;
                position: absolute;
                bottom: 12px;
                left: 50%;
                transform: translateX(-50%);
                padding: 0 4px;
                justify-content: space-between;
                & > div {
                    height: 28px;
                    width: 54px;
                    border-radius: 24px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    &.active {
                        background: #fbfdff;
                    }
                }
            }
            .view_edit {
                position: absolute;
                right: 8px;
                top: 8px;
                height: 30px;
                width: 30px;
                background: rgba($color: #2f2222, $alpha: 0.24);
                border-radius: 6px;
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }
    }

    .practice_dialog {
        ::v-deep .el-dialog.noHeaderFooter {
            background: #fff !important;
            max-height: calc(100% - 24px);
            // background-color: transparent;
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0);
            height: calc(100% - 24px);
            width: 100%;
            border-radius: 0px;
            margin-top: 12px !important;
            .el-dialog__header,
            .el-dialog__footer {
                display: none;
            }
            .el-dialog__body {
                background: none;
                padding: 0;
                margin: 0;
                line-height: 0;
            }

            .el-dialog__body {
                height: 100%;
                .close {
                    right: 0 !important;
                }
            }
        }
    }
</style>
